export const DonateButtonConfig = {
  isHidden: true,
  link: 'https://e-com.novapay.ua/charity?utm_source=PA3.0',
  target: '_blank',
  label: 'Задонать – захисти ППО',
  tooltip: 'Благодійний проєкт Нової пошти та Фонду «Повернись живим»',
};
